// Liest einen Betrag aus einer Nutzereingabe, egal ob als Dezimaltrennzeichen
// ein Komma (deutschsprachig, mobile Tastatur) oder ein Punkt (Desktop,
// Excel-Copy-and-paste) getippt wurde.
//
// Muss dieselbe Regel anwenden wie AmountParser auf dem Server: Wer im Browser
// eine Warnung zu einem Betrag sieht, muss anschließend genau diesen Betrag
// gebucht bekommen. Änderungen also immer in beiden Dateien.
//
// Gibt null zurück, wenn die Eingabe leer oder nicht als Zahl lesbar ist.
export function parseAmount(input) {
  if (input === null || input === undefined) return null

  let digits = String(input).replace(/[^0-9.,+-]/g, "")
  const negative = digits.startsWith("-")
  digits = digits.replace(/^[+-]/, "")
  if (!isReadable(digits)) return null

  const value = parseFloat(normalize(digits))
  if (Number.isNaN(value)) return null

  return negative ? -value : value
}

// Schreibt eine Zahl in deutscher Notation mit zwei Nachkommastellen.
// Muss dasselbe Ergebnis liefern wie AmountInput#format_amount auf dem Server,
// damit ein Betrag nach dem Speichern unverändert aussieht.
export function formatAmount(number) {
  return new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number)
}

// Nach dem führenden Vorzeichen darf nur noch Zahl kommen. "10-15" ist eine
// Spanne, "12,50-" die in Buchhaltungsexporten übliche Schreibweise für minus
// 12,50 -- parseFloat würde beides klaglos abschneiden und eine Zahl liefern,
// die der Server gar nicht annimmt.
function isReadable(digits) {
  return /[0-9]/.test(digits) && /^[0-9.,]+$/.test(digits)
}

// Das letzte Trennzeichen ist das Dezimaltrennzeichen, alle übrigen sind
// Tausendertrennzeichen. Ausnahme: Folgen dem letzten Trennzeichen genau drei
// Ziffern und kommt nur eine Sorte Trennzeichen vor, ist auch das letzte ein
// Tausendertrennzeichen -- "1.234" sind 1234 Euro, denn drei Nachkommastellen
// gibt es bei einem Geldbetrag nicht.
function normalize(digits) {
  const index = Math.max(digits.lastIndexOf("."), digits.lastIndexOf(","))
  if (index === -1) return digits

  const tail = digits.slice(index + 1)
  const separators = digits.match(/[.,]/g) || []
  const singleKind = new Set(separators).size === 1

  if (tail.length === 3 && singleKind) return digits.replace(/[.,]/g, "")

  const head = digits.slice(0, index).replace(/[.,]/g, "")
  return `${head || "0"}.${tail}`
}
